import * as React from 'react';
import { Icon, iconName } from './icons/Icons';
import styled, { css } from 'styled-components';

import { usePopper } from 'react-popper';
import { colors } from './colors/color';

// https://inclusive-components.design/tooltips-toggletips/

type ToggletipProps = {
    icon?: iconName,
    maxWidth?: string,
    children?: React.ReactNode[] | React.ReactNode;
};
export function Toggletip (props: ToggletipProps): JSX.Element
{
    const [focus, setFocus] = React.useState(false);

    const [referenceElement, setReferenceElement] = React.useState(null);
    const [popperElement, setPopperElement] = React.useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: "bottom"
    });

    function showToggletip ()
    {
        popperElement.setAttribute('data-show', true);
    }

    function hideToggletip ()
    {
        popperElement.removeAttribute('data-show');
    }

    return (
        <span style={{ display: 'inline-flex' }}>
            <ToggletipButton
                type='button'
                aria-label="yderligere information"
                //data-toggletip-content={props.text}
                onMouseOver={() => showToggletip()}
                onMouseOut={() =>
                {
                    if (!focus)
                        hideToggletip();
                }}
                onFocus={() =>
                {
                    setFocus(true);
                    showToggletip();
                }}
                onBlur={() =>
                {
                    setFocus(false);
                    hideToggletip();
                }}
                ref={setReferenceElement}>

                <Icon name={props.icon || 'survey_question'} border={false} color={colors.icon.active} sizeOverride={20}></Icon>

            </ToggletipButton>

            <StyledTooltipDiv ref={setPopperElement} style={{ ...styles.popper }} {...attributes.popper} maxWidth={props.maxWidth}>
                {props.children}
            </StyledTooltipDiv>
        </span>
    );
}

const ToggletipButton = styled.button`
    border-radius: 50%;
    padding:0px;
    border:0px;
    background:none;
`;

// Use this
export const TooltipContainerStyle = css`
    background-color:#f8f8f8;
    border-width: 1px;
    border-radius: 4px;
    border-style: solid;
    border-color:  #ccc;
    //border-top: 5px solid #0f0;
    
    font-family: "Noto Sans", sans-serif;
    font-size: 12px;
    color:${colors.text.normal};
    font-weight: 400;
    padding: 10px;
  
    position: relative;
    line-height: 24px;
    z-index: 1000;
`;

export const StyledTooltipDiv = styled.div<{ maxWidth?: string; }>`
    ${TooltipContainerStyle}
    visibility: hidden;
    ${props => props.maxWidth ? `max-width: ${props.maxWidth};` : ''}
    &[data-show="true"] {
        visibility: visible;
    }
`;
